<template>
  <div class="opti-card-wrapper" :style="hideTitle ? 'margin-top: 20px;' : ''">
    <div class="card-header" v-if="!hideTitle">
      <h3 class="card-date" v-if="date">{{ date }}</h3>
      <h3 class="card-title">{{ title }}</h3>
      <!-- <v-divider style="width: 30%; margin: 0 auto; margin-bottom: 10px;"></v-divider> -->
    </div>
    <div class="card-content">
      <div style="text-align: center;" v-if="restricted && !this.$auth.authenticated">Please <a @click="$router.push({ name: 'login' })">Login</a> to access this content</div>
      <slot name="default" v-else></slot>
    </div>
    <!-- <v-divider style="width: 30%; margin: 0 auto; margin-top: 20px;"></v-divider> -->
  </div>
</template>

<script>
const name = 'opti_card'

const props = {
  title: {
    type: String,
    required: false
  },
  date: {
    type: String,
    required: false
  },
  restricted: {
    type: Boolean,
    default: false,
    required: false
  },
  hideTitle: {
    type: Boolean,
    default: false,
    required: false
  }
}

export default {
  name,
  props
}
</script>

<style scoped>
.opti-card-wrapper {
  position: relative;
  margin-bottom: 40px;
}

.card-header {
  display: flex;
  margin: 0 10px 10px 10px;
}

.card-date {
  padding: 3px 10px 0px 10px;
  border-left: 1px solid #757575;
  border-top: 1px solid #757575;
  border-right: 1px solid #757575;
  letter-spacing: 0.05em;
  color: #666;
}

.card-title {
  font-size: 1em;
  font-weight: 500;
  flex: 1;
  color: #424242;
  text-transform: uppercase;
  text-align: start;
  letter-spacing: 0.15em;
  padding: 5px 10px 0px 10px;
  border-bottom: 1px solid #757575;
}

.card-content {
  padding: 10px;
}

@media only screen and (max-width: 420px) {
  .opti-card-wrapper {
    margin: 20px 0px;
  }
  .card-header {
    margin: 0 10px 10px 10px;
  }
  .card-content {
    padding: 10px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/optimus/OptiCard.vue